export enum ClientTypes {
    JS = 1
}
